module.exports = __webpack_public_path__ + "2eaaa6832940415d1b9ed2b591f1ba48.woff2";